import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../../store/actions"

import {
  // Position,
   Email, Phone
} from "./AdminListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import { addNewAdmin, deleteAdmin, getAdmins, updateAdmin } from "../../../store/admins/actions"
import Dropzone from "react-dropzone"
import imageBaseUrl from "../../../helpers/imageBaseUrl"

function Admins() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [offset, setOffset] = useState(0);
  const [page_size,setPageSize]=useState(10)
  const [user, setUser] = useState([])
 const [selectedFiles, setselectedFiles] = useState([])

 function handleAcceptedFiles(files) {
   files.map(file =>
     Object.assign(file, {
       preview: URL.createObjectURL(file),
       formattedSize: formatBytes(file.size),
     })
   )
   console.log(selectedFiles[0])
   setselectedFiles(files)
 }

 /**
  * Formats the size
  */
 function formatBytes(bytes, decimals = 2) {
   if (bytes === 0) return "0 Bytes"
   const k = 1024
   const dm = decimals < 0 ? 0 : decimals
   const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

   const i = Math.floor(Math.log(bytes) / Math.log(k))
   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
 }
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (user && user.username) || "",
      email: (user && user.email) || "",
      phone: (user && user.phone) || "",
      is_active: (user && user.is_active) || 0,
      password: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      // designation: Yup.string().required("Please Enter Your Order Date"),
      email: Yup.string().required("Email is required"),
      phone: Yup.string().required("Phone is required"),
      password: isEdit
        ? Yup.string()
        : Yup.string().required("Password is required"),
    }),

    onSubmit: values => {

      if (isEdit) {
        const updateUser = {
          id: user ? user.id : 0,
          username: values.name,
          // designation: values.designation,
          email: values.email,
          phone: values.phone,
          is_active: values.is_active,
          main_img: selectedFiles[0],
          password:values.password,
          removeImage: user.removeImage ? 1 : 0,
        }

        // update user
        dispatch(updateAdmin(updateUser))
        validation.resetForm()
      } else {
        const newUser = {
          // id: Math.floor(Math.random() * (30 - 20)) + 20,
          username: values["name"],
          phone: values["phone"],
          email: values["email"],
          password: values["password"],
          is_active: values["is_active"],
          main_img: selectedFiles[0],
        }
        // save new user
        dispatch(addNewAdmin(newUser))
        validation.resetForm()
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const users = useSelector(state => state.admins.admins)
  const total_pages = useSelector(state => state.admins.total_page)
  const loading = useSelector(state => state.admins.loading)

  useEffect(() => {
      dispatch(getAdmins({offset,page_size}))
  }, [dispatch,page_size,offset])

  // useEffect(() => {
  //   if (users && !users.length) {
  //     dispatch(onGetUsers())
  //   }
  // }, [dispatch, users])

  // useEffect(() => {
  // }, [users])

  useEffect(() => {
    if (!isEmpty(users)) {
      setIsEdit(false)
    }
  }, [users])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setUser(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const user = arg
      user.main_img ?  setselectedFiles([
          {
            preview: imageBaseUrl + user.main_img,
          },
        ]) : setselectedFiles([])
    setUser({
      id: user.id,
      username: user.username,
      // designation: user.designation,
      email: user.email,
      phone: user.phone,
      is_active: user.is_active,
      

    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = user => {
    setUser(user)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (user.id) {
      dispatch(deleteAdmin(user))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Name",

        filterable: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.main_img ? (
              <div className="avatar-md d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <img
                className="avatar-md rounded-circle me-2"
                // src={cellProps.main_img}
                src={imageBaseUrl + cellProps.main_img}
                alt=""
              />
            )}
            <Link to="#" className="text-body">
              {cellProps.username}
            </Link>
          </React.Fragment>
        ),
      },
      // {
      //   Header: "Position",
      //   accessor: "designation",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Position {...cellProps} />
      //   },
      // },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return <Email {...cellProps} />
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        filterable: true,

        Cell: cellProps => {
          return <Phone {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value.toString() === '1' ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateAdmin({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateAdmin({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const users = cellProps.row.original
                      onClickDelete(users)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick,loading]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Admins" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_pages}
                    setPageSize={setPageSize}
                    page_size={page_size}
                    // loading={loading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Dropzone
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted uil uil-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f, i) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div
                          className="p-2"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                          </Row>
                          <div
                            className="align-self-center"
                            onClick={() => {
                              setselectedFiles([])
                              setUser(prev => ({
                                ...prev,
                                removeImage: true,
                              }))
                            }}
                          >
                            <i
                              className="uil uil-trash-alt font-size-24 text-danger"
                              id="deletetooltip"
                            />
                            <UncontrolledTooltip
                              placement="top"
                              target="deletetooltip"
                            >
                              Delete
                            </UncontrolledTooltip>
                          </div>
                        </div>
                      </Card>
                    )
                  })}
                </div>

                <Row>
                  <Col className="col-12">
                    {/* <div className="mb-3">
                      <Label className="form-label">Position</Label> */}
                    {/* <Input
                        name="designation"
                        type="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                        invalid={
                          validation.touched.designation &&
                          validation.errors.designation
                            ? true
                            : false
                        }
                      /> */}
                    {/* {validation.touched.designation &&
                      validation.errors.designation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.designation}
                        </FormFeedback>
                      ) : null} */}
                    {/* </div> */}
                    <div className="mb-3">
                      <Label className="form-label">Name</Label>
                      <Input
                        name="name"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="email"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Phone</Label>
                      <Input
                        name="phone"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          validation.touched.phone && validation.errors.phone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone && validation.errors.phone ? (
                        <FormFeedback type="invalid">
                          {validation.errors.phone}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Password</Label>
                      <Input
                        name="password"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active.toString() === '1' ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      {/* <input
                        type="checkbox"
                        className="selection-input-4 m-1"
                        defaultChecked={
                          validation.values.is_active === 1 ? true : false
                        }
                      /> */}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Admins.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Admins
